import Photo from 'redhotpie-shared-lib/models/photo';
import { CLUB_MEMBER_TYPE, MEMBER_TYPE_TITLES, MEMBER_TYPES } from '../constants/constants';
import { removePrefixAndSuffix } from '../functions/messageUtils';
import { cleanObjectKeys } from '../functions/utils';
import { IIntersection, IMainPhoto, IMemberTypeTitle, IUserLoginInfo } from '../interfaces/IUser';
import DealBreaker from './dealBreaker';
import MemberProfile from './memberProfile';

export default class User {
  avatarUrl?: string;
  avatarFullUrl: string;
  created_at: string;
  id: number; // this is User's id from API server
  userId: number; // This is RHP user's id
  xmppId: string; // this is XMPP User's id from XMPP server
  location: string;
  old: number;
  firstName: string;
  lastName: string;
  online: boolean;
  sex: string;
  pinned: any[];
  favorites: any[];
  displayName: string;
  isMatch: boolean;
  ageTitle: string;
  countryID?: string;
  memberID?: number;
  memberLevelType?: string;
  memberLevelUserProfile?: string;
  loginToken?: string;
  matchingInterests: number | null;
  isFavorited: boolean;
  isFavoritedMutual: boolean;
  clubMemberType: string;
  bannedFromPosting: boolean;
  isLiked: boolean;
  isLikedMutual: boolean;
  isIgnored: boolean;
  isVerified: boolean;
  isBlocked: boolean;
  isDiamond: boolean;
  hasMessage: boolean;
  dealBreakerConflict: any[];
  dealBreakerConflictViewer: any[];
  matching: any[];
  memberType: number;
  memberTypeTitle: IMemberTypeTitle | string;
  classIfication: number;
  memberLevel: string;
  isUserImage: boolean;
  country: object;
  userType: string;
  isWhisperMessage: boolean;
  profileIntersection: IIntersection;
  isViewable: boolean;
  mainPhotoSummary: IMainPhoto;
  mainPhoto: IMainPhoto;
  stateId: any;
  countryId: any;
  memberTypeId: any;
  birthday1: any;
  birthday2: any;
  age1: any;
  age2: any;
  userName: string;
  isOnline: boolean;
  isOnlineUpdateTime?: Date;
  dateListItem?: string;
  isMatching: boolean;
  parentGroup: {
    id: number;
    name: string;
  };
  isAdmin?: boolean;

  constructor() {
    this.avatarUrl = '';
    this.avatarFullUrl = '';
    this.created_at = '';
    this.id = 0; // this is User's id from API server
    this.userId = -1; // This is RHP user's id
    this.xmppId = ''; // this is XMPP User's id from XMPP server
    this.location = '';
    this.old = 0;
    this.favorites = [];
    this.firstName = '';
    this.lastName = '';
    this.online = false;
    this.sex = '';
    this.pinned = [];
    this.favorites = [];
    this.displayName = '';
    this.isMatch = false;
    this.ageTitle = '';
    this.isFavorited = false;
    this.isFavoritedMutual = false;
    this.clubMemberType = CLUB_MEMBER_TYPE[1];
    this.bannedFromPosting = false;
    this.isLiked = false;
    this.isLikedMutual = false;
    this.isIgnored = false;
    this.isVerified = false;
    this.isBlocked = false;
    this.isDiamond = false;
    this.hasMessage = false;
    this.dealBreakerConflict = [];
    this.dealBreakerConflictViewer = [];
    this.matching = [];
    this.memberType = MEMBER_TYPES.GUEST;
    this.memberTypeTitle = 'Man';
    this.classIfication = 0;
    this.memberLevel = '';
    this.isUserImage = false;
    this.country = {};
    this.userType = '';
    this.isWhisperMessage = false;
    this.profileIntersection = {
      isMatching: true,
      hasFavourited: false,
      hasLiked: false,
      isLikeMutual: false,
      isFavouriteMutual: false,
      hasMessages: false,
    };
    this.isViewable = true;
    this.mainPhotoSummary = {};
    this.mainPhoto = {};
    this.stateId = null;
    this.countryId = null;
    this.memberTypeId = null;
    this.birthday1 = null;
    this.birthday2 = null;
    this.age1 = null;
    this.age2 = null;
    this.userName = '';
    this.isOnline = false;
    this.isOnlineUpdateTime = undefined;
    this.dateListItem = undefined;
    this.isMatching = false;
    this.parentGroup = {
      id: 0,
      name: '',
    };
    this.isAdmin = false;
    this.matchingInterests = null;
  }

  // getShortMemberTypeTitle() {
  //   if (this.memberTypeTitle && typeof this.memberTypeTitle === 'string' && this.memberTypeTitle.length > 0) {
  //     return this.memberTypeTitle.substring(0, 1);
  //   }

  //   // return Guest if no member type defined
  //   return 'G';
  // }

  static mappingObject(_user: any, memberLevel?: number, isRecvMatching?: boolean): IUserLoginInfo {
    if (!_user) return new User() as unknown as IUserLoginInfo;
    let user = Object.assign(new User(), _user);
    user.id = _user.id ? _user.id : 0;
    user.userId = parseInt(_user.userId ? _user.userId : 0);
    user.xmppId = removePrefixAndSuffix(_user.xmppId || _user.senderXmppId);
    user.avatarUrl = _user.avatarUrl; // TODO: remove when there's server setup for image
    user.old = _user.age;
    user.location = _user.location ? _user.location : '';
    user.stateId = _user.stateId ? _user.stateId : '';
    user.countryId = _user.countryId ? _user.countryId : '';
    user.memberTypeId = _user.memberTypeId ? _user.memberTypeId : '';
    user.birthday1 = _user.birthdate1 ? _user.birthdate1 : '';
    user.birthday2 = _user.birthdate2 ? _user.birthdate2 : '';
    user.age1 = _user.birthdate1 ? Math.floor((Date.now() - _user.birthdate1) / (1000 * 60 * 60 * 24 * 365.25)) : ''; //calculate age
    user.age2 = _user.birthdate2 ? Math.floor((Date.now() - _user.birthdate2) / (1000 * 60 * 60 * 24 * 365.25)) : ''; //calculate age
    user.firstName = _user.firstName;
    user.lastName = _user.lastName;
    user.favorites = _user.favorites;
    user.online = _user.online;
    user.memberTypeTitle = _user.memberTypeTitle in MEMBER_TYPE_TITLES ? _user.memberTypeTitle : 'Man';
    user.pinned = _user.pinned || [];
    user.favorites = _user.favorites || [];
    user.displayName = _user.displayName;
    user.userName = _user.displayName;
    user.ageTitle = _user.ageTitle || _user.AgeTitle;
    user.matching = _user.Matching || [];
    user.isFavorite = _user.isFavorite;
    user.isLike = _user.isLike;
    user.isIgnore = _user.isIgnore;
    user.isBlocked = _user.isBlocked;
    user.memberLevel = memberLevel || MEMBER_TYPES.GUEST;
    user.isMatch = isRecvMatching || false;
    user.userType = _user.userType || '';

    user = cleanObjectKeys(Object.keys(new User()), user); // clean other key doesn't exist in user model
    return user;
  }

  static mappingObjectCustom(_user: any): IUserLoginInfo {
    let user = Object.assign(new User(), _user);
    let userId = -1;
    if (!!_user.MemberID) {
      userId = parseInt(_user.MemberID);
    } else if (!!_user.UserID) {
      userId = parseInt(_user.UserID);
    }
    user.id = '';
    user.userId = userId; // _user.UserID;
    user.xmppId = removePrefixAndSuffix(_user.MemberID || _user.UserID);
    user.avatarUrl = _user.MainPhoto ? _user.MainPhoto.ThumbUrl : '';
    user.avatarFullUrl = _user.MainPhoto ? _user.MainPhoto.FullUrl : '';
    user.old = _user.Age1;
    user.location = _user.Location;
    // user.memberTypeTitle = _user.MemberTypeTitle ? _user.MemberTypeTitle.substring(0, 1) : "F";
    user.memberTypeTitle = MemberProfile.mappingMemberTypeTitle(_user.MemberTypeTitle) || {}; // _user.MemberTypeTitle in MEMBER_TYPE_TITLES ? _user.MemberTypeTitle : "Man";
    // user.memberTypeTitle = "Couple MF";
    user.displayName = _user.UserName || _user.Username || _user.Handle || 'Guest';
    user.userName = _user.UserName || _user.Username || _user.Handle || 'Guest';
    user.isMatch = _user.IsMatch;
    user.isVerified = _user.IsVerified;
    user.isFavorited = _user.IsFavourite || _user.HasFavourited || (_user.Intersection ? _user.Intersection.HasFavourited : false);
    user.isLiked = _user.HasLiked || (_user.Intersection ? _user.Intersection.HasLiked : false);
    user.isLikedMutual = _user.IsLikeMutual || (_user.Intersection ? _user.Intersection.IsLikeMutual : false);
    user.isIgnored = _user.isIgnore;
    user.isFavoritedMutual = _user.Intersection ? _user.Intersection.IsFavouriteMutual : false;
    user.userType = _user.UserType || '';
    user.clubMemberType = _user.ClubMemberType || CLUB_MEMBER_TYPE[1];
    user.bannedFromPosting = _user.BannedFromPosting;

    user.dealBreakerConflict = DealBreaker.mappingObjects(
      _user.Intersection && _user.Intersection.DealBreakerConflict ? _user.Intersection.DealBreakerConflict : []
    );
    user.dealBreakerConflictViewer = DealBreaker.mappingObjects(
      _user.Intersection && _user.Intersection.DealBreakerConflictViewer ? _user.Intersection.DealBreakerConflictViewer : []
    );

    user.online = _user.IsOnline;
    user.mobileUrl = _user.MobileURL;
    user.desktopUrl = _user.DesktopURL;
    user.memberLevel = _user.MemberLevel;
    user.memberType = _user.MemberType || MEMBER_TYPES.GUEST;
    user.isWhisperMessage =
      _user.ProfileSettings && _user.ProfileSettings.ChatroomWhisperPermission
        ? _user.ProfileSettings.ChatroomWhisperPermission === 'Anyone'
        : false;

    user.matching = _user.MatchingInterests || [];
    user.ageTitle = _user.AgeTitle || '';
    user.isUserImage = (_user.MainPhoto && _user.MainPhoto.IsUserImage) || false;
    user.country = MemberProfile.mappingMemberCountry(_user.Country) || {};
    user.profileIntersection.isMatching = _user.Intersection ? _user.Intersection.IsMatching : false;
    user.profileIntersection.hasFavourited = _user.Intersection ? _user.Intersection.HasFavourited : false;
    user.profileIntersection.hasLiked = _user.Intersection ? _user.Intersection.HasLiked : false;
    user.profileIntersection.isLikeMutual = _user.Intersection ? _user.Intersection.IsLikeMutual : false;
    user.profileIntersection.isFavouriteMutual = _user.Intersection ? _user.Intersection.IsFavouriteMutual : false;
    user.profileIntersection.hasMessages = _user.Intersection ? _user.Intersection.HasMessages : false;
    user.isViewable = _user.hasOwnProperty('IsViewable') ? _user.IsViewable : true;
    user.mainPhotoSummary =
      (_user.MainPhoto && {
        imageActionType: _user.MainPhoto.ImageActionType,
        photoID: _user.MainPhoto.PhotoID,
        height: _user.MainPhoto.Height,
        width: _user.MainPhoto.Width,
        isPublic: _user.MainPhoto.IsPublic,
        classification: _user.MainPhoto.Classification,
        thumbUrl: _user.MainPhoto.ThumbUrl,
        fullUrl: _user.MainPhoto.FullUrl,
        imageType: _user.MainPhoto.ImageType,
        showSafeMode: _user.MainPhoto.ShowSafeMode,
      }) ||
      null;
    user.mainPhoto = _user.MainPhoto ? Photo.mappingObject(_user.MainPhoto) : null;
    user.isOnline = _user.IsOnline;
    user.dateListItem = _user.DateListItem;
    user.isMatching = _user.IsMatching;
    user.isAdmin = _user.IsAdmin || false;
    user = cleanObjectKeys(Object.keys(new User()), user); // clean other key doesn't exist in user model

    return user;
  }

  static mappingObjectCustomMemberSearch(_user: any): IUserLoginInfo {
    let user = Object.assign(new User(), _user);
    user.id = '';
    user.userId = parseInt(_user.MemberID || _user.UserID); // _user.UserID;
    user.xmppId = removePrefixAndSuffix(_user.MemberID || _user.UserID);
    user.avatarUrl = _user.MainPhoto ? _user.MainPhoto.FullUrl : '';
    user.old = _user.Age1;
    user.location = _user.Location;
    // user.memberTypeTitle = _user.MemberTypeTitle ? _user.MemberTypeTitle.substring(0, 1) : "F"; in MEMBER_TYPE_TITLES ? _user.MemberTypeTitle : "Man";
    user.memberTypeTitle = MemberProfile.mappingMemberTypeTitle(_user.MemberTypeTitle) || {};
    // user.memberTypeTitle = "Couple MF";
    user.isDiamond = _user.IsDiamond;
    user.displayName = _user.UserName || _user.Username || _user.Handle || 'Guest';
    user.userName = _user.UserName || _user.Username || _user.Handle || 'Guest';
    user.isMatch = _user.IsMatch;
    user.isFavorited = _user.IsFavourite || _user.HasFavourited;
    user.isFavoritedMutual = _user.IsFavouriteMutual;
    user.isLiked = _user.HasLiked;
    user.isLikedMutual = _user.IsLikeMutual;
    user.isIgnored = _user.isIgnore;

    user.online = _user.IsOnline;
    user.mobileUrl = _user.MobileURL;
    user.desktopUrl = _user.DesktopURL;
    user.memberType = _user.MemberType || MEMBER_TYPES.GUEST;

    user.matching = _user.MatchingInterests || 0;
    user.ageTitle = _user.AgeTitle || '';

    user.classIfication = (_user.MainPhoto && _user.MainPhoto.Classification) || 0;

    user.memberLevel = _user.MemberLevel || 0;
    user.isUserImage = (_user.MainPhoto && _user.MainPhoto.IsUserImage) || false;
    user.country = MemberProfile.mappingMemberCountry(_user.Country) || {};
    user.mainPhoto = _user.MainPhoto ? Photo.mappingObject(_user.MainPhoto) : null;
    user = cleanObjectKeys(Object.keys(new User()), user); // clean other key doesn't exist in user model
    return user;
  }

  static mappingObjectCustomFriendAndFavorite(_user: any): IUserLoginInfo {
    let user = Object.assign(new User(), _user);
    user.id = '';
    user.userId = parseInt(_user.Detail.UserID); // _user.UserID;
    user.xmppId = _user.Detail.UserID ? _user.Detail.UserID.toString() : '';
    user.avatarUrl = _user.MainPhoto ? _user.MainPhoto.FullUrl : '';
    user.old = _user.Detail.Age1;
    user.location = _user.Detail.Location;
    // user.memberTypeTitle = _user.MemberTypeTitle ? _user.MemberTypeTitle.substring(0, 1) : "F"; in MEMBER_TYPE_TITLES ? _user.MemberTypeTitle : "Man";
    user.memberTypeTitle = MemberProfile.mappingMemberTypeTitle(_user.Detail.MemberTypeTitle) || {};
    // user.memberTypeTitle = "Couple MF";
    user.isDiamond = _user.Detail.IsDiamond;
    user.displayName = _user.Detail.Username;
    user.userName = _user.UserName || _user.Username || _user.Handle || 'Guest';
    user.isMatch = _user.Intersection.IsMatch;
    user.isFavorited = _user.Detail.IsFavourite || _user.Detail.HasFavourited;
    user.isFavoritedMutual = _user.Detail.IsFavouriteMutual;
    user.isLiked = _user.Detail.HasLiked;
    user.isLikedMutual = _user.Detail.IsLikeMutual;
    user.isIgnored = _user.Detail.isIgnore;
    user.hasMessage = _user.Intersection.HasMessages;
    user.online = _user.Detail.IsOnline;
    user.mobileUrl = _user.Detail.MobileURL;
    user.desktopUrl = _user.Detail.DesktopURL;
    user.memberType = _user.Detail.MemberType || MEMBER_TYPES.GUEST;

    user.matching = _user.Detail.MatchingInterests || 0;
    user.ageTitle = _user.Detail.AgeTitle || '';

    user.classIfication = (_user.MainPhoto && _user.MainPhoto.Classification) || 0;

    user.memberLevel = _user.MemberLevel || 0;
    user.isUserImage = (_user.MainPhoto && _user.MainPhoto.IsUserImage) || false;
    user.country = MemberProfile.mappingMemberCountry(_user.Country) || {};
    user = cleanObjectKeys(Object.keys(new User()), user); // clean other key doesn't exist in user model
    return user;
  }

  static mappingMultipleAccount(user: any): Partial<User> {
    return {
      age1: user.Details.Age1,
      age2: user.Details.Age2,
      ageTitle: user.Details.AgeTitle,
      countryID: user.Details.CountryID,
      isAdmin: user.Details.IsAdmin,
      isDiamond: user.Details.IsDiamond,
      isOnline: user.Details.IsOnline,
      isViewable: user.Details.IsViewable,
      location: user.Details.Location,
      matchingInterests: user.Details.MatchingInterests,
      memberID: user.Details.MemberID,
      memberLevel: user.Details.MemberLevel,
      memberLevelType: user.Details.MemberLevelType,
      memberLevelUserProfile: user.Details.MemberLevelUserProfile,
      memberType: user.Details.MemberType,
      memberTypeTitle: MemberProfile.mappingMemberTypeTitle(user.Details.MemberTypeTitle) || 'Member',
      userName: user.Details.UserName,
      userType: user.Details.UserType,
      loginToken: user.LoginToken,
      avatarUrl: user.MainPhoto ? user.MainPhoto.ThumbUrl : '',
      avatarFullUrl: user.MainPhoto ? user.MainPhoto.FullUrl : '',
    };
  }
  static mappingObjectCustomGroupJoinRequest(_user: any): IUserLoginInfo {
    let user: any = {};
    try {
      user.parentGroup = {
        id: _user.ParentClub?.ClubID,
        name: _user.ParentClub?.ClubName,
      };
      user.dateListItem = _user.DateListItem;
      user.userId = parseInt(_user.MemberID);
      user.avatarUrl = _user.MainPhoto ? _user.MainPhoto.FullUrl : '';
      user.userName = _user.UserName;
      user.isMatch = _user.IsMatch;
      user.isFavorited = _user.IsFavourite || _user.HasFavourited;
      user.isFavoritedMutual = _user.IsFavouriteMutual;
      user.isLiked = _user.HasLiked;
      user.isLikedMutual = _user.IsLikeMutual;
      user.isIgnored = _user.isIgnore;
      user.hasMessage = _user.HasMessages;
      user.online = _user.IsOnline;
      user.mobileUrl = _user.MobileURL;
      user.desktopUrl = _user.DesktopURL;
      user.memberType = _user.MemberType || MEMBER_TYPES.GUEST;

      user.matching = _user.MatchingInterests || 0;
      user.ageTitle = _user.AgeTitle || '';

      user.classIfication = (_user.MainPhoto && _user.MainPhoto.Classification) || 0;

      user.memberLevel = _user.MemberLevel || 0;
      user.country = MemberProfile.mappingMemberCountry(_user.Country) || {};
      return user;
    } catch (e) {
      console.log('ERROR: User/mappingObjectCustomGroupJoinRequest:', e);
      return user;
    }
  }

  static mappingObjects(_users: any[]): IUserLoginInfo[] {
    const users: IUserLoginInfo[] = [];
    _users.forEach(_user => {
      const user = User.mappingObject(_user);
      users.push(user);
    });
    return users;
  }

  static mappingObjectsCustom(_users: any[]): IUserLoginInfo[] {
    const users: IUserLoginInfo[] = [];
    _users.forEach(_user => {
      const user = User.mappingObjectCustom(_user.User || _user);
      users.push(user);
    });
    return users;
  }

  static mappingObjectsCustomMemberSearch(_users: any[]): IUserLoginInfo[] {
    const users: IUserLoginInfo[] = [];
    _users.forEach(_user => {
      const user = User.mappingObjectCustomMemberSearch(_user.User || _user);
      users.push(user);
    });
    return users;
  }

  static mappingObjectsCustomFriendAndFavorite(_users: any[]): IUserLoginInfo[] {
    const users: IUserLoginInfo[] = [];
    _users.forEach(_user => {
      const user = User.mappingObjectCustomFriendAndFavorite(_user.User || _user);
      users.push(user);
    });
    return users;
  }

  static mappingObjectsUserFriendActive(_users: any[]): IUserLoginInfo[] {
    const users: IUserLoginInfo[] = [];
    if (_users && _users.length > 0) {
      _users.forEach(_user => {
        const user = User.mappingObjectCustom({ ..._user, ..._user.Detail });
        users.push(user);
      });
    }
    return users;
  }

  static mappingObjectsMultipleAccount(_users: any[]): User[] {
    const users: User[] = [];
    if (_users && _users.length > 0) {
      _users.forEach(_user => {
        const user = User.mappingMultipleAccount(_user);
        users.push(user as User);
      });
    }
    return users;
  }
  static mappingObjectsCustomGroupJoinRequest(_users: any[]): IUserLoginInfo[] {
    const users: IUserLoginInfo[] = [];
    _users.forEach(_user => {
      const user = User.mappingObjectCustomGroupJoinRequest(_user.User || _user);
      users.push(user);
    });
    return users;
  }
}
